import React, { useState, useEffect } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import MapIcon from "@mui/icons-material/Map";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import MailIcon from "@mui/icons-material/Mail";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import PropaneIcon from "@mui/icons-material/Propane";
import Typography from "@mui/material/Typography";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Grid from "@mui/material/Grid";

function DetalleDireccion(props) {
  return (
    <div>
      {props.direccion ? (
        <>
          <List
            sx={{
              width: "100%",
            }}
          >
            <Grid container direction="row" justifyContent="flex-start">
              <Grid item xs={6}>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar sx={{ bgcolor: "#5499C7", width: 30, height: 30 }}>
                      <LocationOnIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={`${props.direccion.direccion_entrega} (${props.direccion.nombre_direccion}),    ${props.direccion.localidad}, ${props.direccion.provincia}.  
                    Zona: ${props.direccion.nombre_zona} - ${props.direccion.descripcion_zona}`}
                    secondary={`Latitud: ${
                      props.direccion.latitud
                        ? props.direccion.latitud
                        : "No Registrada"
                    }. Longitud: ${
                      props.direccion.longitud
                        ? props.direccion.longitud
                        : "No Registrada"
                    }`}
                  />
                </ListItem>
              </Grid>
              {props.direccion.nombre ? (
                <Grid item xs={4}>
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar
                        sx={{ bgcolor: "#5499C7", width: 30, height: 30 }}
                      >
                        <MapIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={`Ruta: ${props.direccion.nombre}`}
                      secondary={`Sucursal: ${props.direccion.sucursal}`}
                    />
                  </ListItem>
                </Grid>
              ) : null}
              {props.direccion.nombre_producto ? (
                <>
                  <Grid item xs={2}>
                    <ListItem>
                      <ListItemAvatar>
                        <Avatar
                          sx={{ bgcolor: "#5499C7", width: 30, height: 30 }}
                        >
                          <PropaneIcon fontSize="small" />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText primary={props.direccion.nombre_producto} />
                    </ListItem>
                  </Grid>
                </>
              ) : null}
              {props.direccion.mails ? (
                <>
                  <Grid item xs={6}>
                    <ListItem>
                      <ListItemAvatar>
                        <Avatar
                          sx={{ bgcolor: "#5499C7", width: 30, height: 30 }}
                        >
                          <MailIcon fontSize="small" />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={props.direccion.mails}
                        secondary={
                          props.direccion.contacto
                            ? `Contacto: ${props.direccion.contacto}`
                            : " "
                        }
                      />
                    </ListItem>
                  </Grid>
                </>
              ) : null}
              {props.direccion.observaciones ? (
                <>
                  <Grid item xs={6}>
                    <ListItem>
                      <ListItemAvatar>
                        <Avatar
                          sx={{ bgcolor: "#5499C7", width: 30, height: 30 }}
                        >
                          <VisibilityIcon fontSize="small" />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={"Observaciones"}
                        secondary={
                          props.direccion.observaciones
                            ? `${props.direccion.observaciones}`
                            : " "
                        }
                      />
                    </ListItem>
                  </Grid>
                </>
              ) : null}
              {props.direccion.telefono_1 ||
              props.direccion.telefono_2 ||
              props.direccion.telefono_3 ? (
                <>
                  <Grid item xs={4}>
                    <ListItem>
                      <ListItemAvatar>
                        <Avatar
                          sx={{ bgcolor: "#5499C7", width: 30, height: 30 }}
                        >
                          <LocalPhoneIcon fontSize="small" />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          <>
                            {props.direccion.telefono_1 ? (
                              <>
                                <Typography
                                  component="span"
                                  variant="body2"
                                  color="text.primary"
                                >
                                  Teléfono 1: {props.direccion.telefono_1}
                                </Typography>
                                <br></br>
                              </>
                            ) : null}
                            {props.direccion.telefono_2 ? (
                              <>
                                <Typography
                                  component="span"
                                  variant="body2"
                                  color="text.primary"
                                >
                                  Teléfono 2: {props.direccion.telefono_2}
                                </Typography>
                                <br></br>
                              </>
                            ) : null}
                            {props.direccion.telefono_3 ? (
                              <>
                                <Typography
                                  component="span"
                                  variant="body2"
                                  color="text.primary"
                                >
                                  Teléfono 3: {props.direccion.telefono_3}
                                </Typography>
                                <br></br>
                              </>
                            ) : null}
                          </>
                        }
                      />
                    </ListItem>
                  </Grid>
                </>
              ) : null}
            </Grid>
          </List>
        </>
      ) : null}
    </div>
  );
}

export default DetalleDireccion;
